<script>
import getErrorMessage from '@/modules/server-errors';

export default {
  name: 'AdminReclassify',
  metaInfo() {
    return { title: this.title };
  },
  data() {
    return {
      title: 'Reclassify'
    };
  },
  created() {
    this.$http
      .put(`/admin/sites/${this.$route.params.siteId}/classify`, {
        classification: this.$route.query.classification
      })
      .then(() => {
        this.$notify({
          type: 'success',
          title: 'Success',
          message: 'The website has been reclassified.'
        });
      })
      .catch(err => {
        // Show an error and redirect to admin
        this.$notify({
          type: 'error',
          title: 'Error',
          message: getErrorMessage(err.response.data.code)
        });
      })
      .finally(() => {
        // Redirect to admin
        this.$router.push({ name: 'Admin' });
      });
  }
};
</script>

<template>
  <span />
</template>
